







import Vue from "vue";
import SystemBarSpace from "../components/SystemBarSpace.vue";
import { toast } from "@bilibili/growup-utils";

export default Vue.extend({
  name: "OldApp",
  components: { SystemBarSpace },
  mounted() {
    document.body.setAttribute("style", "overflow-y: hidden");
    toast("请使用新版本手机端哔哩哔哩参与此活动");
  }
});
